"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PedagogicContentInGameSchema = void 0;
const zod_1 = require("zod");
const PedagogicContentInGameSchema = zod_1.z.object({
    id: zod_1.z.number(),
    title: zod_1.z.string(),
    type: zod_1.z.string(),
    isShown: zod_1.z.boolean(),
    url: zod_1.z.string(),
});
exports.PedagogicContentInGameSchema = PedagogicContentInGameSchema;
